const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

// There is no in-app sign-in page — logging in always means bouncing to the
// BattleNet OAuth flow, which redirects back with a ?token= query param.
export const redirectToBattleNetLogin = () => {
  window.location.href = `${API_URL}/auth/blizzard`;
};
